import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import { Image } from "react-bootstrap";
import CanadaIcon from "../../Images/SignupForm/canadaIcon.png";
import ForgetPassword from "../../Images/SignupForm/forget-password.jpg";
import "../../CSS/UserSignup/index.css";
import {  useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { postApihandler } from "../../ApiHandler";
import swal from "sweetalert";

const ResetPassword = () => {
  const { t } = useTranslation();
  const {register,handleSubmit,reset}=useForm();
  const history = useNavigate();
  const [validated, setValidated] = useState(false);

  const onSubmit = async (value) => {
    console.log("event==>",value.email);
    localStorage.setItem("Email",value.email );
    const res = await postApihandler("/sendResetPasswordMail",value);
    console.log("res-->",res);
    if(res.status === 200){
      swal({
        icon: "success",
        text: `${res.data.message}`,
      }); 
      history("/");
    }
    setValidated(true);
  };

  return (
    <AdminLayout>
      <section className="frgt-pswd-wrapper  py-5 mb-5">
        <div className="forget-img-wrapper text-center">
          <img src={ForgetPassword} alt="" />
        </div>
        <p className="paragraph text-center">{t("reset_password_tagline")}</p>
        <div className="form-Data-Wrapper form-wrapper-column-2 py-4 px-5">
          <div className="form-field-wrapper">
            <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)}>
              <Row className="mb-4">
                <Form.Group as={Col} controlId="validationCustomUsername">
                  <InputGroup hasValidation>
                    <Form.Control
                      type="email"
                      placeholder={t("form_email_text")}
                      aria-describedby="inputGroupPrepend"
                      required
                      {...register("email")}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please fill a email.
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </Row>
              <Form.Group className="text-center mb-4">
                <Button type="submit">{t("form_sbmtBtn")}</Button>
              </Form.Group>
            </Form>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default ResetPassword;
